import { c as _c } from "react/compiler-runtime";
import { ExpandedSearchRecentQueryResult } from "../recent-searches/ExpandedSearchRecentQueryResult";
import { ExpandedSearchAccountResult, mapAccountToSearchResultItem } from "./ExpandedSearchAccountResult";
import { ExpandedSearchCollectionResult, mapCollectionToSearchResultItem } from "./ExpandedSearchCollectionResult";
import { ExpandedSearchCurrencyResult, mapCurrencyToSearchResultItem } from "./ExpandedSearchCurrencyResult";
import { ExpandedSearchItemResult, mapItemToSearchResultItem } from "./ExpandedSearchItemResult";
export const mapRecentSearchToSearchResultItem = recentSearch => {
  return {
    id: recentSearch.timestamp.toString(),
    data: recentSearch,
    type: "recent-search"
  };
};
export function ExpandedSearchRecentResult(t0) {
  const $ = _c(26);
  let item;
  let rest;
  if ($[0] !== t0) {
    ({
      item,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = item;
    $[2] = rest;
  } else {
    item = $[1];
    rest = $[2];
  }
  switch (item.data.type) {
    case "query":
      {
        let t1;
        if ($[3] !== item.data || $[4] !== rest) {
          t1 = <ExpandedSearchRecentQueryResult item={item.data} {...rest} />;
          $[3] = item.data;
          $[4] = rest;
          $[5] = t1;
        } else {
          t1 = $[5];
        }
        return t1;
      }
    case "account":
      {
        let t1;
        if ($[6] !== item.data.data) {
          t1 = mapAccountToSearchResultItem(item.data.data);
          $[6] = item.data.data;
          $[7] = t1;
        } else {
          t1 = $[7];
        }
        let t2;
        if ($[8] !== rest || $[9] !== t1) {
          t2 = <ExpandedSearchAccountResult item={t1} {...rest} />;
          $[8] = rest;
          $[9] = t1;
          $[10] = t2;
        } else {
          t2 = $[10];
        }
        return t2;
      }
    case "collection":
      {
        let t1;
        if ($[11] !== item.data.data) {
          t1 = mapCollectionToSearchResultItem(item.data.data);
          $[11] = item.data.data;
          $[12] = t1;
        } else {
          t1 = $[12];
        }
        let t2;
        if ($[13] !== rest || $[14] !== t1) {
          t2 = <ExpandedSearchCollectionResult item={t1} {...rest} />;
          $[13] = rest;
          $[14] = t1;
          $[15] = t2;
        } else {
          t2 = $[15];
        }
        return t2;
      }
    case "item":
      {
        let t1;
        if ($[16] !== item.data.data) {
          t1 = mapItemToSearchResultItem(item.data.data);
          $[16] = item.data.data;
          $[17] = t1;
        } else {
          t1 = $[17];
        }
        let t2;
        if ($[18] !== rest || $[19] !== t1) {
          t2 = <ExpandedSearchItemResult item={t1} {...rest} />;
          $[18] = rest;
          $[19] = t1;
          $[20] = t2;
        } else {
          t2 = $[20];
        }
        return t2;
      }
    case "currency":
      {
        let t1;
        if ($[21] !== item.data.data) {
          t1 = mapCurrencyToSearchResultItem(item.data.data);
          $[21] = item.data.data;
          $[22] = t1;
        } else {
          t1 = $[22];
        }
        let t2;
        if ($[23] !== rest || $[24] !== t1) {
          t2 = <ExpandedSearchCurrencyResult item={t1} {...rest} />;
          $[23] = rest;
          $[24] = t1;
          $[25] = t2;
        } else {
          t2 = $[25];
        }
        return t2;
      }
  }
}